import Vue from 'vue'
import VueRouter from 'vue-router'
import router from './routes/routes'
import App from './App.vue'
import store from './vuex/store'
import axios from 'axios'
import Cookies from 'js-cookie'

// LightBootstrap plugin and icons

import 'bootstrap-icons/font/bootstrap-icons.min.css'
import LightBootstrap from './light-bootstrap-main'
// import vue-awesome/icons


import 'vue-awesome/icons/cog'
import 'vue-awesome/icons/save'
import 'vue-awesome/icons/angle-left'
import 'vue-awesome/icons/angle-right'
import 'vue-awesome/icons/school'
import 'vue-awesome/icons/map-marked-alt'
import 'vue-awesome/icons/map-marker-alt'
import 'vue-awesome/icons/map-marker'
import 'vue-awesome/icons/plus'
import 'vue-awesome/icons/download'
import 'vue-awesome/icons/paper-plane'
import 'vue-awesome/icons/sync'
import 'vue-awesome/icons/user'
import 'vue-awesome/icons/user-tie'
import 'vue-awesome/icons/random'
import 'vue-awesome/icons/circle'
import 'vue-awesome/icons/route'

/* Register component with one of 2 methods */

import Icon from 'vue-awesome/components/Icon'

// import v-toaster
import Toaster from 'v-toaster'
import 'v-toaster/dist/v-toaster.css'

// import format-price directive
import FormatPrice from './directives/format-price' // Adjust path as necessary
Vue.directive('format-price', FormatPrice)

// plugin setup
Vue.use(Toaster, { timeout: 5000 })
Vue.component('v-icon', Icon)
Vue.use(VueRouter)
Vue.use(LightBootstrap)

import * as VueGoogleMaps from "vue2-google-maps";

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyAPxp_Tz-TfV0blScYhlABF7M7cZ_6DdmA",
    v: "weekly"
  },
  installComponents: true,
});

axios.interceptors.request.use(
  function (config) {
    config.headers = {
      Authorization: 'Bearer ' + Cookies.get('access_token'),
      tokentap: 'Sb7qmGAxCrqdZz370F5cGSNrcQNidjQ2',
      Accept: 'application/json'
    }
    config.onUploadProgress = (progressEvent) => {
      /* store.dispatch(
        "update_upload_percentage",
        Math.round((progressEvent.loaded * 100) / progressEvent.total)
      ); */
    }

    return config
  },
  (error) => Promise.reject(error)
)

Vue.config.productionTip = false
Vue.config.ignoredElements = [/^ion-/]
/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: (h) => h(App),
  router,
  store: store,
  components: { App }
})
